import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface NoteTitlesPullParams {
  userId: string;
  baseUrl: string;
  sta3n: string;
  todaysDate: string;
}

interface NoteTitleEntry {
  [key: string]: unknown;
}

interface NoteTitlesPullResponse {
  entries?: NoteTitleEntry[];
  favorites?: string[];
}

export interface NoteTitlesPullResult {
  entries: NoteTitleEntry[];
  favorites: string[];
}

const normalizeFavorites = (favorites: unknown): string[] => {
  if (!Array.isArray(favorites)) {
    return [];
  }

  return Array.from(
    new Set(
      favorites
        .map((value) => (typeof value === "string" ? value.trim() : ""))
        .filter(Boolean)
    )
  );
};

export function useNoteTitlesPull(params: NoteTitlesPullParams | null) {
  return useQuery({
    queryKey: [
      "note-titles",
      params?.userId ?? null,
      params?.baseUrl ?? null,
      params?.sta3n ?? null,
      params?.todaysDate ?? null,
    ],
    enabled: params !== null,
    retry: false,
    queryFn: async () => {
      if (!params) {
        return { entries: [], favorites: [] } as NoteTitlesPullResult;
      }

      const { userId, baseUrl, sta3n, todaysDate } = params;
      const data = await api.post<NoteTitlesPullResponse>("/va/note-titles/pull", {
        user_id: userId,
        base_url: baseUrl,
        sta3n,
        todays_date: todaysDate,
      });
      return {
        entries: Array.isArray(data?.entries) ? data.entries : [],
        favorites: normalizeFavorites(data?.favorites),
      } as NoteTitlesPullResult;
    },
  });
}

export default useNoteTitlesPull;
